import * as React from 'react';
import { Box } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import { AppBar } from '@mui/material/node';
import Typography from '@mui/material/Typography';
import { ProfilMenuItem } from '../profilMenuItem';


export const UserAppBar = (props) => {

  return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Typography
              variant="h6"
              noWrap
              component="a"
              // href="/"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              NodeCanvas
            </Typography>
            <ProfilMenuItem userData={props.userData}></ProfilMenuItem>
          </Toolbar>
        </AppBar>
      </Box>
    );
}